import * as React from 'react';

import {
    TextField,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    Button,
    Select,
    MenuItem,
    FormControl,
    Grid,
    Typography,
} from '@mui/material';
import { useUtilityContext } from '../../utility-provider';
import { apiRequest } from '../../api/ApiCall';
import { LOCAL_CONSTANT } from '../Const';
import { userLogging } from "../../utility/firestore";
import { useUserContext } from "../../user-provider";
export interface commentDialogProps {
    props: {
        open: boolean,
        params: any,
        pages: any[],
        handleModal: React.Dispatch<React.SetStateAction<boolean>>,
        handleSaveComment: () => void
        handleCanCelComment: () => void
    }
}

export const ChangeHistoryTableComment: React.FC<commentDialogProps> = ({ props }) => {
    const [open, setOpen] = React.useState<boolean>(false)
    const [disabled, setDisabled] = React.useState<boolean>(true)
    const [comment, setComment] = React.useState("")
    const [selectedPage, setSelectedPage] = React.useState("")
    const utilityCtx = useUtilityContext();
    const user = useUserContext();

    React.useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    // バリデーション関数
    const validateForm = () => {
        return comment.trim() !== "" && selectedPage !== "";
    }

    const handleCommentChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setComment(e.target.value)
        setDisabled(!validateForm() && !(e.target.value.trim() !== "" && selectedPage !== ""))
    }

    const handlePageChange = (event: any) => {
        setSelectedPage(event.target.value)
        setDisabled(!(comment.trim() !== "" && event.target.value !== ""))
    }

    const registComment = () => {
        // コメント登録
        const params = {
            mode: "regist",
            endPoint: "/location/system/v1/put-rfc-rr-log",
            query: {
                plan_area_id: props.params.planAreaId,
                branch: props.params.branch,
                log_type: "99",
                comment: comment,
                target_table: selectedPage,
                target_column: "コメント"
            }
        };
        // userLogging
        userLogging(
            LOCAL_CONSTANT.FUNCTION_NAME.RFC_ITEM_CHANGE_HISTORY_COMMENT,
            params,
            user
        );
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                await apiRequest(params);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
                setComment("")
                setSelectedPage("")
                //モーダルを閉じる
                props.handleSaveComment()
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
                setComment("")
                setSelectedPage("")
                //モーダルを閉じる
                props.handleSaveComment()
            }
        })();
    }

    const closeComment = () => {        
        //モーダルを閉じる
        setComment("")
        setSelectedPage("")
        props.handleCanCelComment()
    }

    const handleDialogClose = () => {
        props.handleModal(false);
    }

    return (
        <>
            <Dialog open={open} onClose={handleDialogClose} fullWidth>
                <DialogContent>
                    <Grid container spacing={2}>
                        {/* ページ選択 */}
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                <Typography variant="body1" sx={{ width: "65px" }}>
                                    {LOCAL_CONSTANT.LABEL.PAGE}
                                </Typography>
                                <FormControl size="small" sx={{ width: "335px" }}>
                                    <Select
                                        value={selectedPage}
                                        onChange={handlePageChange}
                                        displayEmpty
                                    >
                                        {props.pages.map((page: any) => (
                                            <MenuItem key={page.code_value} value={page.code_value}>
                                                {page.code_display}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Grid>
                        
                        {/* コメント入力 */}
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                <Typography variant="body1" sx={{ width: "65px" }}>
                                    コメント
                                </Typography>
                                <TextField
                                    variant="outlined"
                                    value={comment}
                                    multiline
                                    rows={3}
                                    onChange={(e) => handleCommentChange(e)}
                                    sx={{ width: "335px" }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Box sx={{ display: 'flex', justifyContent: "space-around", margin: '10px' }}>
                    <DialogActions>
                        <Button
                            variant="outlined" color="error" size="small"
                            onClick={() => closeComment()}>
                            {LOCAL_CONSTANT.LABEL.CANCEL}
                        </Button>
                    </DialogActions>
                    <DialogActions>
                        <Button
                            variant="contained" color="success" size="small"
                            disabled={disabled}
                            onClick={() => registComment()}>
                            {LOCAL_CONSTANT.LABEL.REGIST_LABEL}
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </>
    )
}

export default ChangeHistoryTableComment;
